// extracted by mini-css-extract-plugin
export default {"tabsContainer":"TabsView_tabsContainer__f4e78","tabsHeader":"TabsView_tabsHeader__ZjORp","active":"TabsView_active__OkRIj","tabBody":"TabsView_tabBody__13-gj"};